import React from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'underscore';
import { SmartActionButton } from '@bingads-webui-campaign-react/smart-component-action-button';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = components => ({
  secondaryBtn: {
    ...components.defaultButton,
  },
  primaryBtn: {
    ...components.primaryButton,
  },
});

const UnStyledButtonList = ({
  actionButtons,
  compactMode,
  buttonListClassName,
  buttonItemClassName,
  classes,
  useIconButton,
  disabled,
}) => {
  const buttons = actionButtons.map(({ actionType }) => (
    <li key={actionType} className={buttonItemClassName}>
      <SmartActionButton
        id={uniqueId('header_cta_')}
        className={useIconButton ? '' : classes.secondaryBtn}
        overrideButtonConfig={{
          actionType,
        }}
        useIconButton={useIconButton}
        disabled={disabled}
      />
    </li>));

  return compactMode ? null : (
    <ul className={buttonListClassName}>
      {buttons}
    </ul>
  );
};

UnStyledButtonList.propTypes = {
  compactMode: PropTypes.bool.isRequired,
  actionButtons: PropTypes.arrayOf(PropTypes.shape({
    actionType: PropTypes.string.isRequired,
  })).isRequired,
  buttonListClassName: PropTypes.string.isRequired,
  buttonItemClassName: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    primaryBtn: PropTypes.string.isRequired,
  }).isRequired,
  useIconButton: PropTypes.bool,
  disabled: PropTypes.bool,
};

UnStyledButtonList.defaultProps = {
  useIconButton: false,
  disabled: false,
};

export const ButtonList = withDefaultStyles(
  UnStyledButtonList,
  getStyles
);
